import { Bar } from '../../js/bar.es6'
import('normalize.css/normalize.css')
import('../../css/main.css')
import('./page.css')

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded', 'page-index')
})

console.log(window.Bar)
